module.exports = __webpack_public_path__ + "static/img/10.6fa4d8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/10.png
// module id = 288
// module chunks = 0